import React from "react";
import AccountOverall from "../Components/Account/AccountOverall";

function Account() {
  return (
    <>
      <AccountOverall />
    </>
  );
}

export default Account;
